module.exports = __webpack_public_path__ + "static/img/nuclear-power-plant_256.9ddbcf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nuclear-power-plant_256.png
// module id = LuxQ
// module chunks = 0